import initCmsPageType from './extension/sw-cms/init/cmsPageType.init';

// extensions
import './extension/sw-cms/page/sw-cms-detail';
import './extension/sw-cms/component/sw-cms-list-item';
import './extension/sw-cms/component/sw-cms-create-wizard';

import './extension/entity/sw-entity-many-to-many-select'

// entry module
import './module/acris-blogs';

// blog modules
import './module/acris-blog';
import './module/acris-blog-group';
import './module/acris-blog-author';

// cms
import './module/sw-cms/component/sw-cms-sidebar';

import './module/sw-cms/blocks/acris-blog';
import './module/sw-cms/blocks/acris-blog-title';
import './module/sw-cms/blocks/acris-blog-subtitle';
import './module/sw-cms/blocks/acris-blog-author-date';
import './module/sw-cms/blocks/acris-blog-image';
import './module/sw-cms/blocks/acris-blog-image-slider';
import './module/sw-cms/blocks/acris-blog-content';
import './module/sw-cms/blocks/acris-blog-product-slider';

import './module/sw-cms/elements/acris-blog-group';
import './module/sw-cms/elements/acris-blog-title';
import './module/sw-cms/elements/acris-blog-subtitle';
import './module/sw-cms/elements/acris-blog-author-date';
import './module/sw-cms/elements/acris-blog-image';
import './module/sw-cms/elements/acris-blog-image-slider';
import './module/sw-cms/elements/acris-blog-content';
import './module/sw-cms/elements/acris-blog-product-slider';

initCmsPageType();
